import request from '@/router/axios'

// 获取所有证书模板
export function getCertModels () {
  return request({
    url: '/basic/admin/cert/template/list',
    method: 'get',
  })
}

// 创建证书
export function createCert (obj) {
  return request({
    url: '/basic/admin/cert',
    method: 'post',
    data: obj,
  })
}

// 编辑证书
export function certEdit (obj) {
  return request({
    url: '/basic/admin/cert',
    method: 'put',
    data: obj,
  })
}

// 删除证书
export function certDel (id) {
  return request({
    url: `/basic/admin/cert/${id}`,
    method: 'delete',
  })
}

// 证书列表
export function getCertList (param) {
  return request({
    url: '/basic/admin/cert/page',
    method: 'get',
    params: param,
  })
}

// 手动发放证书
export function postCert (obj) {
  return request({
    url: '/basic/admin/cert/manual-issue',
    method: 'post',
    data: obj,
  })
}

// 证书详情
export function getCertDetail(id) {
  return request({
    url: `/basic/admin/cert/${id}`,
    method: 'get',
  })
}

// 证书发放记录
export function getCertRecords(param) {
  return request({
    url: `/basic/admin/cert/record/page`,
    method: 'get',
    params: param
  })
}

// 导出证书发放记录
export function exportCertRecords(param) {
  return request({
    url: `/basic/admin/cert/record/export`,
    method: 'get',
    params: param
  })
}

export function getMemberInfo(id) {
  return request({
    url: `/admin/admin/member/unionId/${id}`,
    method: 'get',
  })
}

// 收回/激活已发放给用户的证书
export function switchRecord (id) {
  return request({
    url: `/basic/admin/cert/record/${id}`,
    method: 'post',
  })
}

// 下载证书发放模板
export function getPostTemplate() {
  return request({
    url: '/basic/admin/cert/issue-template',
    method: 'get',
  })
}

// 根据excel批量发放证书
export function postCerts(param, id) {
  return request({
    url: `/basic/admin/cert/${id}/batch-issue`,
    method: 'post',
    data: param
  })
}
